import React, { useMemo } from 'react';
import { TableFieldApplications } from '@innovationnorway/kunde-raskavklaring-visning';
import { useOneWayIn } from 'src/features/one-way-in';
import { useParams } from 'react-router-dom';
import { PageParams } from 'src/features/one-way-in/opportunity-details/types/PageParams';
import { useTranslation } from 'react-i18next';

const CompanyInformationApplicationsTab = () => {
  const { formId } = useParams<PageParams>();
  const { oneWayInGroupedFormQuery } = useOneWayIn(formId);
  const { t: tSiva } = useTranslation('siva');
  const form = oneWayInGroupedFormQuery.data;

  const applications = useMemo(() => {
    if (!form?.grupper) {
      return [];
    }

    return form.grupper.find((group) => group.navn === 'Tidligere søknader')?.felter?.[0]?.felter || [];
  }, [form]);

  return (
    <>
      <h3>{tSiva('companyTabs.applications.title')}</h3>
      <TableFieldApplications navn={tSiva('companyTabs.applications.table.title')} felter={applications} />
    </>
  );
};

export default CompanyInformationApplicationsTab;
